module.exports = __webpack_public_path__ + "static/IE-app-e5463dd4b51399288ed2a0434b185076.png";